<template>
  <section id="features" class="features">
      <div class="section-caption">{{ $t("featured_features") }}</div>
      <div class="container" id="listFeature">
        <div class="row" >
          <div class="col-sm" v-for="(feature, index) in features" :key="index">
            <div class="feature-container">
              <img
                :src="feature.image_jpg"
                :alt="feature.title"
                class="feature-img center"
                v-vpshow-scroll
              />
              <div class="feature-headline" v-html="feature.title"></div>
              <div class="feature-content"  v-html="feature.description"></div>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>

export default {
  name: 'Feature',
  data() {
    return {
      features: [],
      loadingBanner: true,
    };
  },
  mounted() {
    this.$store.dispatch('fetchFeaturepage', {
      language: this.$store.getters.getLanguage,
      limit: 3,
      search_param: '',
      page: 1,
    });
  },
  created() {
    this.$store.watch(
      (state) => state.homepageFeature,
      (newValue) => {
        this.loadingBanner = true;
        this.features = newValue;
        this.loadingBanner = false;
      },
    );
    this.$store.watch(
      (state) => state.language,
      (newValue) => {
        this.$store.dispatch('fetchFeaturepage', {
          language: newValue,
          limit: 3,
          earch_param: '',
          page: 1,
        });
      },
    );
  },
};
</script>

<style scoped>
.desktop-home .feature {
  margin: 0px;
  padding: 0px;
  margin-bottom: 100px;
}
.desktop-home .section-caption {
  margin-left: 100px;
}
.desktop-home .feature-img {
  width: 100px;
  height: 100px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.feature-headline {
  text-align: center;
  font-family: "GothamMedium";
  font-size: 24px;
  line-height: 27px;
  letter-spacing: 0px;
  font-weight: normal;
  padding-bottom: 10px;
  padding-top: 10px;
}
.feature-content {
  text-align: center;
  font-family: "GothamBook", Helvetica, sans-serif;
  font-size: 16px;
  line-height: 27px;
  letter-spacing: 0px;
  font-weight: normal;
}
</style>
